const popoverStyles = {
  anchororigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformorigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  getcontentanchorel: null,
};

export default popoverStyles;
